import { fetcher } from '#lib/backendFetcher';

/**
 * Adds a new step (email template) to a campaign.
 * @param {Object} params
 * @param {string} params.campaignId - UUID of the campaign
 * @param {string} params.emailTemplateId - UUID of the email template
 * @param {number} params.delayDays - Delay in days from the previous step
 * @returns {Promise<{data: Object, error: null}>}
 */
export const addCampaignStep = async ({ campaignId, emailTemplateId, delayDays }) => {
	const data = await fetcher(`/api/v1/email/campaigns/crud/${campaignId}/steps`, {
		method: 'POST',
		body: { emailTemplateId, delayDays },
	});
	return { data, error: null };
};

/**
 * Updates a campaign step (change template or delay).
 * @param {Object} params
 * @param {string} params.stepId - UUID of the step
 * @param {string} params.campaignId - UUID of the campaign
 * @param {Object} params.updates - Fields to update
 * @returns {Promise<{error: null}>}
 */
export const updateCampaignStep = async ({ stepId, campaignId, updates }) => {
	await fetcher(`/api/v1/email/campaigns/crud/${campaignId}/steps/${stepId}`, {
		method: 'PATCH',
		body: updates,
	});
	return { error: null };
};

/**
 * Deletes a campaign step.
 * @param {Object} params
 * @param {string} params.campaignId - UUID of the campaign
 * @param {string} params.stepId - UUID of the step
 * @returns {Promise<{error: null}>}
 */
export const deleteCampaignStep = async ({ campaignId, stepId }) => {
	await fetcher(`/api/v1/email/campaigns/crud/${campaignId}/steps/${stepId}`, {
		method: 'DELETE',
	});
	return { error: null };
};

// Backwards-compatible aliases (used by existing code that hasn't migrated yet)
export const insertSingleEmailOfCampaign = addCampaignStep;
export const updateSingleEmailData = updateCampaignStep;
export const deleteSingleEmailOfCampaign = deleteCampaignStep;
